import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "swiper/css";
import "swiper/css/navigation";

import { getCategoryList } from "../../../api/services";

const CategorySlider = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategoryList();
      setCategories(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  // Navigation only when data is loaded
  const showNavigation = !loading && categories.length > 6;

  // Skeleton Card UI
  const CategorySkeleton = () => {
    return (
      <div className="item text-center">
        <div className="cat-img-block">
          <Skeleton height={120} width={120} style={{ borderRadius: "50%" }} />
        </div>

        <div className="cat_description" style={{ marginTop: "10px" }}>
          <Skeleton width={120} height={20} />
        </div>
      </div>
    );
  };

  return (
    <div className="shop_by_department_slider_wrap">
      <div className="container">
        <div className="shop_by_department_slider_head">
          <h3
            className="content-title theme_color text-center"
            style={{ marginBottom: "20px" }}
          >
            Shop By Category
          </h3>

          {/* Navigation Buttons */}
          {showNavigation && (
            <>
              <div
                className="category-swiper-prev"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "-5px",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "#fff",
                  borderRadius: "50%",
                  padding: "8px",
                  cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  width: "40px",
                  height: "40px",
                }}
              >
                <GoChevronLeft size={22} />
              </div>

              <div
                className="category-swiper-next"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "-5px",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "#fff",
                  borderRadius: "50%",
                  padding: "8px",
                  cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  width: "40px",
                  height: "40px",
                }}
              >
                <GoChevronRight size={22} />
              </div>
            </>
          )}

          {/* Swiper */}
          <Swiper
            slidesPerView={6}
            spaceBetween={20}
            className="category-slide"
            loop={!loading && categories.length > 6}
            autoplay={
              !loading
                ? {
                    delay: 3000,
                    disableOnInteraction: false,
                  }
                : false
            }
            navigation={
              showNavigation
                ? {
                    nextEl: ".category-swiper-next",
                    prevEl: ".category-swiper-prev",
                  }
                : false
            }
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: { slidesPerView: 2, spaceBetween: 10 },
              576: { slidesPerView: 3, spaceBetween: 15 },
              768: { slidesPerView: 4, spaceBetween: 20 },
              1024: { slidesPerView: 6, spaceBetween: 20 },
            }}
          >
            {/* Skeleton Loader */}
            {loading
              ? Array.from({ length: 6 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <CategorySkeleton />
                  </SwiperSlide>
                ))
              : categories.map((cat) => (
                  <SwiperSlide key={cat.id}>
                    <div className="item text-center">
                      <div className="cat-img-block">
                        <Link to={`/category/${cat.slug}`}>
                          <img
                            src={cat.image}
                            alt={cat.name}
                            loading="lazy"
                            className="cat-img"
                          />
                        </Link>
                      </div>

                      <div className="cat_description">
                        <Link to={`/category/${cat.slug}`}>{cat.name}</Link>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default CategorySlider;
